import React from 'react';
import './animated-svg.css';

const AnimatedEmailSending: React.FC = () => {
	return (
		<div
			className='animated-svg-container-manual-trigger'
			style={{
				width: '130px',
				display: 'block',
				margin: '40px auto 0',
				left: '-10px',
				position: 'relative',
			}}
		>
			<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 195 101' fill='none'>
				<path
					d='M193.735 98.5436C194.244 97.8423 194.509 96.9795 194.517 96.1156V4.47499C194.561 2.23007 192.579 0.259067 190.338 0.295919H59.1212C56.8793 0.259447 54.8981 2.23007 54.9421 4.47499V96.1156C54.9053 98.3575 56.8789 100.34 59.1239 100.295H190.335C191.664 100.302 192.97 99.6309 193.735 98.5436ZM63.3003 13.4676L93.8026 39.1962L63.3003 82.8406V13.4676ZM147.316 35.2968C147.315 35.2983 147.313 35.2994 147.311 35.301L127.601 51.9268C125.884 53.3758 123.575 53.3755 121.859 51.9268L102.148 35.301C102.147 35.2994 102.145 35.2979 102.143 35.2964L70.5574 8.65406H178.902L147.316 35.2968ZM100.218 44.6078L116.469 58.3159C118.901 60.3674 121.815 61.3928 124.729 61.3928C127.644 61.3928 130.558 60.367 132.99 58.3159L149.241 44.6078L182.318 91.9369H67.1405L100.218 44.6078ZM155.657 39.1962L186.159 13.4676V82.8406L155.657 39.1962Z'
					fill='var(--color-main-primary)'
				/>
				<path
					d='M34.1136 29.9063H14.141C11.833 29.9063 9.96191 28.0352 9.96191 25.7272C9.96191 23.4192 11.833 21.5481 14.141 21.5481H34.1136C36.4216 21.5481 38.2927 23.4192 38.2927 25.7272C38.2927 28.0352 36.4216 29.9063 34.1136 29.9063Z'
					fill='var(--color-support-primary)'
				/>
				<path
					d='M34.1128 49.9939H4.17909C1.87109 49.9939 0 48.1228 0 45.8148C0 43.5068 1.87109 41.6357 4.17909 41.6357H34.1128C36.4208 41.6357 38.2918 43.5068 38.2918 45.8148C38.2918 48.1228 36.4208 49.9939 34.1128 49.9939Z'
					fill='var(--color-support-primary)'
				/>
				<path
					d='M34.1136 70.0818H14.141C11.833 70.0818 9.96191 68.2107 9.96191 65.9027C9.96191 63.5947 11.833 61.7236 14.141 61.7236H34.1136C36.4216 61.7236 38.2927 63.5947 38.2927 65.9027C38.2927 68.2107 36.4216 70.0818 34.1136 70.0818Z'
					fill='var(--color-support-primary)'
				/>
			</svg>
		</div>
	);
};

export default AnimatedEmailSending;
